import ContactHero from './components/ContactHero';
import MapSection from './components/MapSection';
import TrustBar from './components/TrustBar';

export default function ContactPage() {
  return (
    <main>
      <ContactHero />
      <MapSection />
      <TrustBar />
    </main>
  );
}